var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V8V13C0 14.6569 1.34315 16 3 16H11.5H15C16.6569 16 18 14.6569 18 13V8V3C18 1.34315 16.6569 0 15 0H11.5H6.5H3ZM10.5 2H7.5V7H10.5V2ZM12.5 7V2H15C15.5523 2 16 2.44772 16 3V7H12.5ZM10.5 9H7.5V14H10.5V9ZM12.5 14V9H16V13C16 13.5523 15.5523 14 15 14H12.5ZM3 2H5.5V7H2V3C2 2.44772 2.44772 2 3 2ZM2 9H5.5V14H3C2.44772 14 2 13.5523 2 13V9Z",
    fill: "#B5B7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTask);
export default __webpack_public_path__ + "static/media/allTask.decf3fe01e551b478c9e70d8b7d14326.svg";
export { ForwardRef as ReactComponent };